import { Button, Form, Input, Select } from 'antd';
import React from 'react';
import { useWarehouse } from './WarehouseStore';

function Add() {
    const { addWarehouse, shops } = useWarehouse();
    const [form] = Form.useForm();

    return (
        <Form form={form} layout="vertical" onFinish={(values) => {
            addWarehouse(values);
            form.resetFields();
        }}>
            <Form.Item label="Nomi" name="name" rules={[{ required: true, message: "Nom kiritilishi shart" }]}>
                <Input placeholder="Sklad nomini kiriting" />
            </Form.Item>
            <Form.Item label="Manzili" name="location" rules={[{ required: true, message: "Manzil kiritilishi shart" }]}>
                <Input placeholder="Manzilni kiriting" />
            </Form.Item>
            <Form.Item label="Do'kon" name="shop_id" rules={[{ required: true, message: "Do'kon tanlanishi shart" }]}>
                <Select options={shops} placeholder="Do'konni tanlang" />
            </Form.Item>
            <Form.Item>
                <Button htmlType="submit" type="primary" block>Sklad qo'shish</Button>
            </Form.Item>
        </Form>
    );
}

export default Add;